import React from 'react'
import { useNavigate } from 'react-router'
import { cn } from '@/utils/cn'
import { useTheme } from '@/hooks/useTheme'

export interface FooterProps {
  className?: string
}

const Footer: React.FC<FooterProps> = ({ className }) => {
  const { isDark } = useTheme()
  const navigate = useNavigate()
  const currentYear = new Date().getFullYear()

  // Theme-aware styling using useTheme hook pattern
  const footerBgClass = isDark ? 'bg-secondary-900' : 'bg-white'
  const borderClass = isDark ? 'border-secondary-700' : 'border-neutral-200'
  const textClass = isDark ? 'text-secondary-300' : 'text-secondary-600'
  const linkClass = cn(
    'hover:underline transition-colors duration-200 cursor-pointer',
    isDark
      ? 'text-primary-400 hover:text-primary-300'
      : 'text-primary-600 hover:text-primary-700'
  )

  const handleAboutClick = () => {
    navigate('/about')
  }

  const handleTermsClick = () => {
    navigate('/terms')
  }

  const handlePrivacyClick = () => {
    navigate('/privacy')
  }

  const handleContactClick = () => {
    window.location.href = 'mailto:support@bitewise.com.au'
  }

  return (
    <footer className={cn(
      footerBgClass,
      borderClass,
      'mt-auto',
      className
    )}>
      <div className="max-w-7xl mx-auto px-8 py-12">
        {/* Bottom Section */}
        <div className={cn('pt-8 border-t', borderClass)}>
          <div className="flex justify-center items-center">
            <div className={cn('text-sm text-center', textClass)}>
              © {currentYear} BiteWise | {' '}
              <button
                onClick={handleAboutClick}
                className={cn('cursor-pointer', linkClass)}
                aria-label="About BiteWise"
              >
                About
              </button>
              {' '} | {' '}
              <button
                onClick={handleTermsClick}
                className={cn('cursor-pointer', linkClass)}
                aria-label="View Terms of Service"
              >
                Terms of Service
              </button>
              {' '} | {' '}
              <button
                onClick={handlePrivacyClick}
                className={cn('cursor-pointer', linkClass)}
                aria-label="View Privacy Policy"
              >
                Privacy Policy
              </button>
              {' '} | {' '}
              <button
                onClick={handleContactClick}
                className={cn('cursor-pointer', linkClass)}
                aria-label="Contact Us"
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export { Footer }